const GCB2StartPage = () => import('@/views/GCB2/StartPage.vue')

export default [
    {
        path: '/project/:id/GCB2/doctorReportLoreal',
        name: 'GCB2DoctorReportLoreal',
        props: { dashboardType: 'doctorReportLoreal' },
        component: GCB2StartPage,
    },
]

